import React, { useState, useEffect } from 'react'
import { TextInput, Button, Flex, Stack, Text, Title, Card, ActionIcon, Modal } from '@mantine/core'
import { IconTrash } from '@tabler/icons-react'
import logos from './Logos'
import styled from "styled-components";

import EntityActionAssociatorForm from './EntityActionAssociatorForm'

const Logo = styled.img`
  width: 24px;
  height: 24px;
  object-fit: contain;
`;

export default function EntityActionProvider({
  providerInfo = { title: "", id: "", label: "", provider: "", provider_name: "" },
  onSubmit = () => { },
  onAddEvent = () => { }
}) {
  const [formValues, setFormValues] = useState({
    provider_id: "",
  })

  useEffect(() => {
    setFormValues({ ...formValues, provider_id: providerInfo.id })
  }, [providerInfo.id]);

  return <Card>
    <Stack gap="xs">
      <Flex gap="xs" align="center">
        <Logo src={logos[providerInfo.provider]} />
        <Text fw={600} size="lg">{providerInfo.title}</Text>
      </Flex>
      {providerInfo.id ? <Flex gap="xs" align="center">
        <Title order={3}>{providerInfo.id}</Title>
        <ActionIcon color="gray" variant="light" size="xs" radius="xl" onClick={() => onSubmit("")}>
          <IconTrash size={12} />
        </ActionIcon>
      </Flex> : <Flex gap="xs" align="center">
        <TextInput
          placeholder={providerInfo.label}
          value={formValues.provider_id}
          style={{ flex: 1 }}
          onChange={(e) => setFormValues({ ...formValues, provider_id: e.target.value })}
        />
        <Button size="sm" disabled={providerInfo.id === "" && formValues.provider_id === ""} onClick={() => onSubmit(formValues.provider_id)}>Save</Button>
      </Flex>}
      {providerInfo?.id && <AddEvent providerInfo={providerInfo} onSubmit={onAddEvent} />}
    </Stack>
  </Card>
}

const AddEvent = ({ providerInfo, onSubmit = () => { } }) => {
  const [opened, setOpened] = useState(false);

  return <div>
    <Button size="xs" radius="lg" variant="light" onClick={() => setOpened(true)}>Add {providerInfo.provider_name} Event</Button>
    <Modal title={`Add ${providerInfo.provider_name} Event`} opened={opened} onClose={() => setOpened(false)}>
      <EntityActionAssociatorForm onItemSubmit={(item) => {
        setOpened(false);
        onSubmit(item)
      }} providerInfo={providerInfo} />
    </Modal>
  </div>
}